import React, {Component} from 'react';
import './ActivityCouponCard.css';
import {Link, withRouter} from 'react-router-dom';
import {Avatar, OptionsButton, PrimaryButton} from '../../widgets';
import * as moment from 'moment';
import {connect} from 'react-redux';
import couponActions from '../../community/coupons/coupons.actions';
import {uiActions} from '../../chrome';
import confirmActions from '../../widgets/confirmation.actions';

class ActivityCouponCard extends Component {
	componentWillUnmount() {
		this.props.clearModels();
	}

	onCouponClickHandler = e => {
		if (this.props.redirectLink) {
			this.props.history.push(this.props.redirectLink);
		}
	};

	onAvtarClickHandler = e => {
		e.stopPropagation();
		if (this.props.providerProfileLink) {
			this.props.history.push(this.props.providerProfileLink);
		}
	};

	render() {
		const {
			size,
			screenSize,
			avatarImage,
			firstname,
			lastname,
			businessName,
			description,
			code,
			productLink,
			couponUuid,
			expiryDate,
			children,
			showActions,
			options,
			couponCommunity,
			confirmReedem,
			coupon,
			clearModels,
			canRedeem,
			onRedeem,
			showRedeemButton
		} = this.props;

		const style = {
			float: 'left'
		};

		const paddFloat = {
			width: '100%',
			float: 'left'
		};

		const padd = {
			padding: '10px'
		};

		const backgroundColor = {
			backgroundColor: '#d38c05',
			color: '#fff',
			fontWeight: 'bold'
		};

		const paddingStripe = {
			padding: '5px'
		};

		const couponExpiry = moment(expiryDate, 'YYYY-MM-DD');
		const currentDate = moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD');

		const diffDays = couponExpiry.diff(currentDate, 'days') + 1;

		let showQuantity = false;
		let showSoldOut = false;

		if (coupon.quantity - coupon.totalRedeemed <= 10) {
			showQuantity = true;
		}

		if (coupon.quantity === coupon.totalRedeemed) {
			showSoldOut = true;
		}

		return (
			<div style={paddFloat} onClick={this.onCouponClickHandler} className="streamCouponCard">
				<div style={{...paddingStripe, ...backgroundColor}}>
					<span>{coupon.community.name}</span>
				</div>
				<div style={{...style, ...padd}}>
					<div className="ActivityCouponHeader">
						<div className="CouponCard-meta">
							<Avatar
								size={size === 'small' ? 64 : screenSize === 'mobile' ? 100 : 128}
								backgroundImage={avatarImage}
								onClick={this.onAvtarClickHandler}
							/>
						</div>
						<div className="CouponCard-bio">
							<h2 className="provider-name" onClick={this.onAvtarClickHandler}>
								{firstname} {lastname}
							</h2>

							{businessName ? (
								<div className="CouponCard-businessName" onClick={this.onAvtarClickHandler}>
									{businessName}
								</div>
							) : (
								undefined
							)}
						</div>
					</div>
					<div className="CouponCardBody">
						<p className="Description">{description}</p>

						{productLink && productLink.length > 0 && (
							<div className="productLink">
								{/* <Link to={{ pathname: productLink }} target="_blank" /> */}
								<a href={productLink} target="_blank" rel="noopener noreferrer">
									{productLink}
								</a>
							</div>
						)}
					</div>
					<div style={paddFloat}>
						<span className="PromoCode">
							Code: <span>{code}</span>
						</span>
						<span className="ExpiryDate">
							Expires: {moment(expiryDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
						</span>
						<div className="couponActivityFooter">
							{!showActions && showSoldOut && (
								<div className="quantityLeft">
									<span className="soldOut">SOLD OUT</span>
								</div>
							)}

							{!showActions && !showQuantity && !showSoldOut && diffDays < 7 && (
								<div className="daysleft">
									<img className="timerImage" src="/timer.png" alt="timer icon" />
									<span>
										Only {diffDays} {diffDays > 1 ? 'days' : 'day'} left!
									</span>
								</div>
							)}

							{!showActions && !showSoldOut && showQuantity && (
								<div className="quantityLeft">
									<span>Hurry, Only {coupon.quantity} Left</span>
								</div>
							)}

							{showRedeemButton && (
								<div className="couponActivityActions">
									<span className="redeemButton">
										<PrimaryButton
											disabled={!canRedeem}
											icon="loyalty"
											onClick={e => {
												e.stopPropagation();
												confirmReedem(coupon);
											}}>
											Redeem
										</PrimaryButton>
									</span>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {
		confirmReedem: coupon => {
			dispatch(
				confirmActions.open({
					title: `Are you sure you want to redeem this Coupon?`,
					message: 'The coupon will be added to your coupon cart. Are you sure?',
					onConfirm: () => {
						dispatch(couponActions.redeemCoupon(coupon));
					}
				})
			);
		},
		clearModels: () => {
			dispatch(uiActions.uiModal(''));
		}
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(ActivityCouponCard)
);



// WEBPACK FOOTER //
// ./src/stream/activity-coupon-card/ActivityCouponCard.js